// extracted by mini-css-extract-plugin
module.exports = {"SideNavWrapper":"LayoutWrapperAccountSettingsSideNav_SideNavWrapper__1d3c7","SideNavFooter":"LayoutWrapperAccountSettingsSideNav_SideNavFooter__2QfZm"};